import LoanRequest, { key } from '../../api/loanRequest'
import { AppString } from '../../strings'
import { Pagination } from '../common.js'

const pagination  = new Pagination(LoanRequest)

export const state = {
    ...pagination.state,
}

export const getters = {
    ...pagination.getters
}

export const actions = {
    ...pagination.actions,

    update({ commit, dispatch }, payload) {
        // TODO: add failed notification on all api request
        return LoanRequest.update(payload[key], payload.params).then(response => {
            if (response.status === 200) {
                commit('UPDATE_LOAN_REQUEST', {
                    [key]: payload[key],
                    loanRequest: response.data
                })
                dispatch('notifications/addSuccessNotification', AppString.loanRequestUpdated, { root: true })
            }

            return response
        })
    },

    save({ commit, dispatch }, payload) {
        return LoanRequest.create(payload).then(response => {
            
            if (response.status === 201) {
                commit('ADD_LOAN_REQUEST', response.data)
                dispatch('notifications/addSuccessNotification', AppString.loanRequestCreated, { root: true })
            }

            return response
        })
    },

    delete({ commit, dispatch }, loanRequest) {
        return LoanRequest.delete(loanRequest[key]).then(response => {
            if (response.status === 204) {
                commit('DELETE_LOAN_REQUEST', loanRequest)
                dispatch('notifications/addSuccessNotification', AppString.loanRequestDeleted, { root: true })
            }

            return response
        })
    },

    view(_, loanRequest) {
        return LoanRequest.view(loanRequest[key]).then(response => {
            if (response.status === 200) {
                return response.data 
            }
        })
    },

    // REVIEW: is this still used?
    searchByName({ dispatch }, payload) {
        return dispatch('fetchPagination', {
            'filter[or][][name][like]': payload,
            expand: 'profile'
        })
    },

    approve({ commit, dispatch }, loanRequest) {
        return LoanRequest.approve(loanRequest[key]).then(response => {
            if (response.status === 200) {
                commit('CHANGE_STATUS', { loanRequest, status: response.data.status })
                dispatch('notifications/addSuccessNotification', "Loan request approved", { root: true })
            }

            return response
        })
    },

    deny({ commit, dispatch }, loanRequest) {
        return LoanRequest.deny(loanRequest[key]).then(response => {
            if (response.status === 200) {
                commit('CHANGE_STATUS', { loanRequest, status: response.data.status })
                dispatch('notifications/addSuccessNotification', "Loan request denied", { root: true })
            }

            return response
        })
    },
}

export const mutations = {
    ...pagination.mutations,
    CHANGE_STATUS(state, { loanRequest, status }) {
        loanRequest.status = status
    },


    ADD_LOAN_REQUEST(state, loanRequest) { state.all.unshift(loanRequest) },

    UPDATE_LOAN_REQUEST(state, payload) {
        const loanRequest = state.all.find(loanRequest => 
            loanRequest[key].toString().toLowerCase() === payload[key].toString().toLowerCase())

        if (loanRequest)
            Object.assign(loanRequest, payload.loanRequest)
    },

    DELETE_LOAN_REQUEST(state, loanRequest) {
        const index = state.all.findIndex(item => item === loanRequest)

        if (index >= 0) {
            state.all.splice(index, 1)
            // update pagination items length
            // --state.pagination.itemsLength
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
